export function convertMonthYearToISO(monthYear) {
    // Split the input string into month and year
    const parts = monthYear.split(' ');
    
    if (parts.length !== 2) {
        // Invalid input format
        return "";
    }
  
    const monthAbbreviation = parts[0];
    const year = parts[1];
  
    const months = {
        'Jan': '01',
        'Feb': '02',
        'Mar': '03',
        'Apr': '04',
        'May': '05',
        'Jun': '06',
        'Jul': '07',
        'Aug': '08',
        'Sep': '09',
        'Oct': '10',
        'Nov': '11',
        'Dec': '12'
    };
  
    if (months[monthAbbreviation]) {
        // Month found in the mapping, convert to ISO format
        const isoDate = year + '-' + months[monthAbbreviation];
        return isoDate;
    } else {
        // Invalid month abbreviation
        return "";
    }
}

export function convertISOToMonthYear(isoDate) {
    const dateParts = isoDate.split('-');
  
    if (dateParts.length !== 2) {
        // Invalid input format
        return "";
    }
  
    const year = dateParts[0];
    const month = dateParts[1];
  
    const months = {
        '01': 'Jan',
        '02': 'Feb',
        '03': 'Mar',
        '04': 'Apr',
        '05': 'May',
        '06': 'Jun',
        '07': 'Jul',
        '08': 'Aug',
        '09': 'Sep',
        '10': 'Oct',
        '11': 'Nov',
        '12': 'Dec'
    };
  
    if (months[month]) {
        // Month found in the mapping, convert to "MMM YYYY" format
        const monthYearStr = months[month] + ' ' + year;
        return monthYearStr;
    } else {
        // Invalid month format
        return "";
    }
}

export function monthYearDifference(date1, date2) {
    
    // convert  month year to iso
    let date1Iso = convertMonthYearToISO(date1)
    let date2Iso = convertMonthYearToISO(date2)

    // Parse the input dates
    var parts1 = date1Iso.split('-');
    var parts2 = date2Iso.split('-');

    var year1 = parseInt(parts1[0], 10);
    var month1 = parseInt(parts1[1], 10);

    var year2 = parseInt(parts2[0], 10);
    var month2 = parseInt(parts2[1], 10);

    // Calculate the difference in months
    var monthDiff = (year2 - year1) * 12 + (month2 - month1);
    
    return monthDiff + 1;
}

export function addMonthYear(monthYear, monthsToAdd) {
    const date = new Date(monthYear);
    date.setMonth(date.getMonth() + monthsToAdd);
    const year = date.getFullYear();
    const month = date.getMonth().toString().padStart(2, '0'); // Ensure 2 digits for month
    return `${year}-${month}`;
}

export function distinctById(arr, id) {
    const distinctValues = {};
    arr.forEach(item => {
        distinctValues[item[id]] = item;
    });
    return Object.values(distinctValues);
}